import { ComponentType, ReactNode } from 'react';
import classes from './FigmaWhiteLayout.module.scss';

const DefaultRenderForm: FigmaWhiteLayoutProps['RenderForm'] = ({
  children,
  className,
}) => <div className={className}>{children}</div>;

export type FigmaWhiteLayoutProps = {
  slotHeader: ReactNode;
  slotTitle?: ReactNode;
  slotButtons?: ReactNode;
  RenderForm?: ComponentType<{ className: string; children: ReactNode }>;
  slotError?: ReactNode;
  children: ReactNode;
  slotBottom?: ReactNode;
};
export const FigmaWhiteLayout = ({
  slotHeader,
  slotTitle,
  slotButtons,
  RenderForm = DefaultRenderForm,
  slotError,
  children,
  slotBottom,
}: FigmaWhiteLayoutProps) => {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <h2 className={classes.header}>{slotHeader}</h2>
        <RenderForm className={classes.form}>
          {slotTitle && <div className={classes.title}>{slotTitle}</div>}
          <div>{children}</div>
          <div className={classes.placeholder} />
          {slotError && <div className={classes.error}>{slotError}</div>}
          {slotButtons}
          {slotBottom && <div className={classes.bottom}>{slotBottom}</div>}
        </RenderForm>
      </div>
    </div>
  );
};
